<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar dark color="indigo">
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Update Route Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="save()">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <h2>Route Details</h2>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="name" label="Route Name"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="label" label="Label"></v-text-field>
            </v-col>
            <!-- <v-col cols="6">
              <v-select
                v-model="security_level"
                :items="security_level_items"
                label="Security Level"
              ></v-select>
            </v-col> -->
            <v-col cols="6">
              <v-select
                v-model="urgency"
                :items="security_level_items"
                label="Urgency Level"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-datetime-picker
                label="Date and Time Due"
                v-model="datetime_due"
              >
              </v-datetime-picker>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="subject"
                label="Route Subject"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row>
            <v-col cols="12" v-if="errorMessage">
              <h3 class="text-center red--text">{{ errorMessage }}</h3>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2';
import { mapActions } from 'vuex';
export default {
  name: "UpdateRouteDetails",
  props: {
    dialog: Boolean,
    selectedRoute: Object
  },
  data() {
    return {
        content: "Details",
        name: "",
        label: "",
        // security_level: "",
        status: "",
        urgency: "",
        subject: "",
        datetime_due: '',
        errorMessage: null,
        security_level_items: ["Low", "Moderate", "High"],
    }
  },
  methods: {
    ...mapActions(['updateRouteDetails']),
    save() {
        const body = {
            name: this.name,
            label: this.label,
            // security_level: this.security_level,
            urgency: this.urgency,
            subject: this.subject,
            datetime_due: this.datetime_due,
            route_id: this.selectedRoute.id
        }

        this.updateRouteDetails(body)
            .then(() => {
                Swal.fire(
                    'Success',
                    'Route details updated',
                    'success'
                ).then(() => {
                    this.$emit('closeDialog', true);
                })
            })
            .catch(err => console.log(err));

    },
    close() {
      this.$emit('closeDialog', false);
    }
  },
  watch: {
    dialog: function () {
      if(this.dialog) {
          this.name = this.selectedRoute.name;
          this.label = this.selectedRoute.label;
          // this.security_level = this.selectedRoute.security_level;
          this.urgency = this.selectedRoute.urgency;
          this.subject = this.selectedRoute.subject;
          this.datetime_due = new Date(this.selectedRoute.datetime_due);
      }
    }
  }
};
</script>

<style>
</style>